import type { CampaignMetadata } from '../../types';
import type { TeamInvitationData, TeamMemberData } from '../../types/n8nResponses';

export const normalizeManagerId = (value: string | null | undefined): string | null =>
  !value || value === 'null' ? null : value;

export const buildActiveTeamMembers = (
  teamMembers: TeamMemberData[],
  teamInvitations: TeamInvitationData[] = []
): TeamMemberData[] => {
  const acceptedInvitations = teamInvitations.filter(
    (invite) => invite.status === 'accepted' && (invite.user_id || invite.email)
  );

  const seen = new Set<string>();
  return [...teamMembers, ...acceptedInvitations].filter((member) => {
    const memberKey = member.user_id || member.email.trim().toLowerCase();
    if (seen.has(memberKey)) return false;
    seen.add(memberKey);
    return true;
  });
};

export const resolveTeamLeader = (
  teamMembers: TeamMemberData[],
  preferredEmail?: string | null
): TeamMemberData | null => {
  const normalizedPreferredEmail = preferredEmail?.trim().toLowerCase() || null;

  return (
    teamMembers.find((member) => member.roles?.includes('owner')) ||
    teamMembers.find((member) => member.roles?.includes('teamadmin')) ||
    (normalizedPreferredEmail
      ? teamMembers.find((member) => member.email.trim().toLowerCase() === normalizedPreferredEmail)
      : null) ||
    teamMembers[0] ||
    null
  );
};

export const resolveCampaignOwner = (
  campaign: CampaignMetadata,
  teamMembers: TeamMemberData[],
  preferredLeaderEmail?: string | null
): TeamMemberData | null => {
  const managerId = normalizeManagerId(campaign.account_manager_id);
  const explicitManager = managerId
    ? teamMembers.find((member) => member.user_id === managerId) || null
    : null;

  if (explicitManager) return explicitManager;
  return resolveTeamLeader(teamMembers, preferredLeaderEmail);
};
